/* eslint-disable @typescript-eslint/no-explicit-any */
'use client'

import { useRouter } from "next/navigation";
import React, { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { format } from 'date-fns';
import { Input } from '@/components/ui/input';
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@/components/ui/select";
import Form from 'next/form';
import SearchButton from "./search-button";

function DropdownSelect({ options, valueKey, labelKey, defaultValue, defaultLabel, onChange }: any) {
    return (
        <Select
            name="modalidade"
            defaultValue={defaultValue || ''}
            onValueChange={(value) => onChange(value)}
        >
            <SelectTrigger className="w-max-fit">
                <SelectValue placeholder={defaultLabel} />
            </SelectTrigger>
            <SelectContent>
                {options?.map((option: any) => (
                    <SelectItem
                        key={option[valueKey]}
                        value={option[valueKey]}
                        onChange={() => onChange(option[valueKey])}
                    >
                        {option[labelKey]}
                    </SelectItem>
                ))}
            </SelectContent>
        </Select>
    );
}

export default function Filters({ data }: { data: any }) {
    const router = useRouter();
    const [filters, setFilters] = useState({ dia: '', modalidade: '', busca: '' });
    const [uniqueStartDates, setUniqueStartDates] = useState<string[]>([]);
    const [searchValue, setSearchValue] = useState(""); // Novo estado para o valor do campo de busca

    const optionsModalidades = [
        { MOD_IDEN: 'TODAS', MOD_NOME: 'TODAS' },
        { MOD_IDEN: 'ONLINE', MOD_NOME: 'ONLINE' },
        { MOD_IDEN: 'PRESENCIAL', MOD_NOME: 'PRESENCIAL' },
        { MOD_IDEN: 'HIBRIDO', MOD_NOME: 'HIBRIDO' }
    ];

    useEffect(() => {
        const daysSet = new Set<string>();

        data.forEach((item: {
            ATIV_DATA_INICIO: string,
            SUBATIV_DATA_INICIO: string
        }) => {
            let formattedDate = '';

            if (item.ATIV_DATA_INICIO) {
                formattedDate = format(new Date(item.ATIV_DATA_INICIO), 'dd-MM-yyyy');
            }
            if (item.SUBATIV_DATA_INICIO) {
                formattedDate = format(new Date(item.SUBATIV_DATA_INICIO), 'dd-MM-yyyy');
            }

            daysSet.add(formattedDate);
        });

        const sortedDates = Array.from(daysSet).sort((a, b) => {
            const [dayA, monthA, yearA] = a.split('-').map(Number);
            const [dayB, monthB, yearB] = b.split('-').map(Number);
            return yearA - yearB || monthA - monthB || dayA - dayB;
        });

        setUniqueStartDates(sortedDates);
    }, [data]);

    type FilterType = 'dia' | 'modalidade' | 'busca';

    const toggleFilter = (filterType: FilterType, value: string) => {
        setFilters((prev) => {
            const isAlreadySelected = prev[filterType] === value;
            return {
                ...prev,
                [filterType]: isAlreadySelected ? '' : value // Desmarca o filtro se já estiver selecionado
            };
        });
    };

    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setSearchValue(value); // Atualiza o estado local do campo de busca
        toggleFilter('busca', value);
    };

    const clearFilters = () => {
        setFilters({ dia: '', modalidade: '', busca: '' });
        setSearchValue(''); // Limpa o valor do campo de busca
        router.replace('?', { scroll: false });
    };

    const isFilterApplied = Object.values(filters).some(value => value);

    return (
        <div className="  bg-gray-200 p-2 max-sm:flex-col rounded-xl mx-auto w-11/12 lg:w-11/12 2xl:w-9/12 ">
            <Form action="" scroll={false} className="flex gap-4 max-sm:flex-col justify-between">

                <div className="flex gap-2 overflow-x-auto p-2">
                    {uniqueStartDates.map(dayMonth => {
                        const [day, month] = dayMonth.split('-');
                        const isSelected = filters.dia === dayMonth;

                        return (
                            <label key={dayMonth} className="flex">
                                <input
                                    type="checkbox" // Alterado para checkbox
                                    name="dia"
                                    value={dayMonth}
                                    checked={isSelected}
                                    onChange={() => toggleFilter('dia', dayMonth)}
                                    className="hidden" // Esconde o input de checkbox
                                />
                                <Button
                                    onClick={() => toggleFilter('dia', dayMonth)}
                                    className={`${isSelected
                                        ? "bg-curious-blue-500 text-white hover:bg-curious-blue-600"
                                        : "text-bay-of-many-900 bg-white hover:bg-curious-blue-500 hover:text-white"
                                        }`}
                                >
                                    {day}/{month}
                                </Button>
                            </label>
                        );
                    })}
                </div>

                <div className="flex gap-2 p-2">
                    <DropdownSelect
                        options={optionsModalidades}
                        valueKey="MOD_IDEN"
                        labelKey="MOD_NOME"
                        defaultValue=""
                        defaultLabel="Modalidades"
                        onChange={(value: any) => setFilters(prev => ({ ...prev, modalidade: value }))}
                    />

                    <Input
                        type="search"
                        id="search"
                        name="busca"
                        autoComplete="off"
                        placeholder="Digite para buscar..."
                        value={searchValue} // Controlado pelo estado searchValue
                        onChange={handleSearchChange}
                    />

                    <SearchButton />

                    {isFilterApplied && (
                        <Button variant="link" onClick={clearFilters}>
                            Limpar
                        </Button>
                    )}
                </div>
            </Form>


        </div>
    );
}
